import { useNavigate } from "react-router-dom";
import { toast } from "@/core/components/ui/toast";
import { useCreateReport } from "./query";
import { profitabilityRunPath } from "./routes";
import type { ProfitabilityRun } from "./types";
import { reportError } from "./utils";
/**
 * Builds this report's period again. A rerun is how a report catches up with
 * jobs that closed out after it ran, so it is the same action whether the
 * report succeeded, failed, or lost its workbook.
 *
 * It creates a new run rather than replacing this one, so nothing an owner
 * already downloaded stops existing, and the new run is what the period's row
 * resolves to once it completes.
 */
export const useRerunReport = (businessId: string, run: ProfitabilityRun) => {
  const navigate = useNavigate();
  const create = useCreateReport(businessId);

  return {
    rerunning: create.isPending,
    rerun: () =>
      create.mutate(
        { start_date: run.start_date, end_date: run.end_date },
        {
          onSuccess: (started) => navigate(profitabilityRunPath(started.id)),
          onError: (error) =>
            toast.error("The report could not be started", {
              description: reportError(error),
            }),
        },
      ),
  };
};
